import { Table } from "antd";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import Status from "./status";
import CopyData from "../../../components/CopyData";
const expandedRowRender = (record) => {
    if (record.persons && record.persons.length > 1) {
      return (
        <div>
          <Table
            rowKey="msr_persons_name"
            columns={[
              { title: 'LP', dataIndex: 'msr_persons_id',width: "149px", render: (item, record) => (
                <div>
                    
                </div>
              ), },
              { title: 'ID osoby', dataIndex: 'msr_persons_own_id', width: "150px", render: (item, record) => (
                <div>
                    
                </div>
              ) },
              { title: 'Imię i nazwisko', dataIndex: 'msr_persons_lastname', width: "250px", render: (item, record) => (
                <div style={{display: 'flex', gap: '10px'}}>
                    <CopyData item={`#${record.msr_persons_own_id} ${record.msr_persons_name} ${record.msr_persons_lastname}`} />
                    <div style={{padding: '2px 5px', background: 'rgb(233 233 233)', fontSize: '13px', color: 'black',  borderRadius: '5px', width: 'fit-content', fontFamily: 'Courier New, Courier, monospace', height: 'fit-content'}}>
                      #{record.msr_persons_own_id}
                    </div>
                    <div>
                      {record.msr_persons_name} {record.msr_persons_lastname}
                    </div>
                </div>
              )  },
              {
                title: 'Kwota wpływu',
                dataIndex: 'msr_persons_amount',
                width: '200px',
                key: 'msr_persons_amount',
                render: (item, record) => (
                  <div style={{fontSize: '14px', fontWeight: 700,  textAlign: 'right'}}>
                      {formatPrice(item)} zł
                  </div>
                ),
              },
              {
                title: 'Kwota odliczenia',
                dataIndex: 'msr_persons_deduction',
                width: '200px',
                key: 'msr_persons_deduction',
                render: (item, record) => (
                  <div style={{fontSize: '14px', fontWeight: 700,  textAlign: 'right'}}>
                      {formatPrice(item)} zł
                  </div>
                ),
              },
              {
                title: 'Rachunek wpływu',
                width: '200px',
                dataIndex: 'msr_bank_accounts_name',
                key: 'msr_bank_accounts_name',
                render: (item) => (
                  <div style={{ fontSize: '14px', fontWeight: 700, textAlign: 'right' }}>
                    j.w.
                  </div>
                ),
              },
              {
                title: 'Data wpływu',
                dataIndex: 'msr_persons_created_datetime',
                key: 'msr_persons_created_datetime',
                width: "150px",
                render: (item, record) => (
                  <div>
                      {datetimeParser(item, "YYYY-MM-DD")}
                  </div>
                ),
              },
                  {
                    title: 'Data wpływu na rachunek rozliczeniowy',
                    dataIndex: 'msr_wplywy_date_forward',
                    key: 'msr_wplywy_date_forward',
                    width: "250px",
                    render: (item) => (
                      <div>
                        {item && item != 'null' ? datetimeParser(item, "YYYY-MM-DD") : 'Nie przekazano'}
                      </div>
                    ),
                  },
              {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (item, record) => (
                  <Status wplyw={record}></Status>
                ),
              },
              {
                title: 'Ostatnia zmiana',
                dataIndex: 'last_person_change',
                key: 'last_person_change',
                render: (item, record) => (
                  item ? <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
                    <div>{datetimeParser(item, "YYYY-MM-DD")}</div>
                    <div style={{padding: '2px 5px', background: 'rgb(233 233 233)', fontSize: '13px', color: 'black',  borderRadius: '5px', width: 'fit-content', height: 'fit-content'}}>
                    {datetimeParser(item, "HH:mm")}
                    </div>
                  </div> : 
                    <div>
                      Brak danych
                  </div>
                ),
              },            
            ]}
            dataSource={record.persons}
            pagination={false}
            showHeader={false} // Optional: Hide header for nested table
          />
        </div>
      );
    }
    return null;
  };

  export default expandedRowRender